import RestClient from '@/api/api';

class IDFApi extends RestClient {
  async getInterpolatedData(latitude, longitude, options = {}) {
    return this._get('/idf/interpolated', {
      params: {
        lat: latitude,
        lon: longitude,
        num_stations: options.numStations || 4,
        power: options.power || 2.0,
        max_distance_km: options.maxDistanceKm || 100
      }
    })
  }
}

export default new IDFApi();
